/** Display name for a registrar type id (e.g. "porkbun" → "Porkbun"). */
const NAMES: Record<string, string> = {
  ilkari: 'Ilkari',
  porkbun: 'Porkbun',
  safenames: 'Safenames',
  godaddy: 'GoDaddy',
  namecheap: 'Namecheap',
  namesilo: 'NameSilo',
  dynadot: 'Dynadot',
  dreamhost: 'DreamHost',
  domainconz: 'domain.co.nz',
};

export function registrarName(type: string | null | undefined): string {
  if (!type) return 'the registrar';
  const id = type.toLowerCase().split('-')[0];
  return NAMES[id] ?? id.charAt(0).toUpperCase() + id.slice(1);
}
